module.exports = __webpack_public_path__ + "static/media/Gastro-IBD-IBS-1@3x.e8057f7a.png";